export default __webpack_public_path__ + "static/media/soil_moisture-active.09302272.svg";